import React from 'react';
import { getPercentile } from '../utils/percentile';

interface ResultCardProps {
  score: number;
  resultTitle: string;
  resultImage: string;
  quizTitle?: string;
  gradient?: [string, string];
  siteLabel?: string;
  baseValue?: number;
  resultUnit?: string;
  percentileMean?: number;
  percentileSd?: number;
}

const ResultCard = React.forwardRef<HTMLDivElement, ResultCardProps>(
  ({
    score,
    resultTitle,
    resultImage,
    quizTitle = '기대수명 테스트',
    gradient = ['#FFD6FF', '#C9A0DC'],
    siteLabel = '기대수명테스트.com',
    baseValue = 84,
    resultUnit = '살',
    percentileMean = 16,
    percentileSd = 15,
  }, ref) => {
    const value = baseValue + score;
    const percentile = getPercentile(score, percentileMean, percentileSd);

    return (
      <div
        ref={ref}
        style={{
          width: '1080px',
          height: '1080px',
          background: `linear-gradient(135deg, ${gradient[0]} 0%, ${gradient[1]} 60%, ${gradient[0]} 100%)`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: "'TTLaundryGothicB', sans-serif",
          position: 'absolute',
          left: '-9999px',
          top: '-9999px',
        }}
      >
        <div style={{ fontSize: '48px', color: '#333', marginBottom: '20px', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
          {quizTitle}
        </div>

        <div style={{ fontSize: '100px', fontWeight: 'bold', color: '#1a1a2e', margin: '20px 0' }}>
          {value}{resultUnit}
        </div>

        <img
          src={resultImage}
          alt={resultTitle}
          style={{ width: '280px', height: '280px', margin: '20px 0' }}
          crossOrigin="anonymous"
        />

        <div style={{ fontSize: '56px', fontWeight: 'bold', color: '#2d2d2d', margin: '10px 0' }}>
          {resultTitle}
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.6)',
          borderRadius: '50px',
          padding: '15px 40px',
          fontSize: '36px',
          color: '#6a1b9a',
          fontWeight: 'bold',
          margin: '20px 0',
        }}>
          상위 {percentile}%
        </div>

        <div style={{ fontSize: '28px', color: '#666', marginTop: '40px' }}>
          나도 테스트하기 → {siteLabel}
        </div>
      </div>
    );
  }
);

ResultCard.displayName = 'ResultCard';

export default ResultCard;
